import { MediaUIEvents, MediaUIAttributes } from "../constants.js";
const splitTextTracksStr = (textTracksStr = "") => textTracksStr.split(/\s+/);
const parseTextTrackStr = (textTrackStr = "") => {
  const [language, encodedLabel] = textTrackStr.split(":");
  const label = encodedLabel ? decodeURIComponent(encodedLabel) : void 0;
  return {
    language,
    label
  };
};
const parseTextTracksStr = (textTracksStr = "", textTrackLikeObj = {}) => {
  return splitTextTracksStr(textTracksStr).map((textTrackStr) => {
    const textTrackObj = parseTextTrackStr(textTrackStr);
    return {
      ...textTrackLikeObj,
      ...textTrackObj
    };
  });
};
const parseTracks = (trackOrTracks) => {
  if (Array.isArray(trackOrTracks)) {
    return trackOrTracks.map((trackObjOrStr) => {
      if (typeof trackObjOrStr === "string") {
        return parseTextTrackStr(trackObjOrStr);
      }
      return trackObjOrStr;
    });
  }
  if (typeof trackOrTracks === "string") {
    return parseTextTracksStr(trackOrTracks);
  }
  return [trackOrTracks];
};
const formatTextTrackObj = ({ label, language } = {}) => {
  if (!label)
    return language;
  return `${language}:${encodeURIComponent(label)}`;
};
const stringifyTextTrackList = (textTracks = []) => {
  return Array.prototype.map.call(textTracks, formatTextTrackObj).join(" ");
};
const isMatchingPropOf = (key, value) => (obj) => obj[key] === value;
const textTrackObjAsPred = (filterObj) => {
  const preds = Object.entries(filterObj).map(([key, value]) => {
    return isMatchingPropOf(key, value);
  });
  return (textTrack) => preds.every((pred) => pred(textTrack));
};
const updateTracksModeTo = (mode, tracks = [], tracksToUpdate = []) => {
  const preds = parseTracks(tracksToUpdate).map(textTrackObjAsPred);
  const isTrackToUpdate = (textTrack) => {
    return preds.some((pred) => pred(textTrack));
  };
  Array.from(tracks).filter(isTrackToUpdate).forEach((textTrack) => {
    textTrack.mode = mode;
  });
};
const getTextTracksList = (media, filterPredOrObj = () => true) => {
  if (!(media == null ? void 0 : media.textTracks))
    return [];
  const filterPred = typeof filterPredOrObj === "function" ? filterPredOrObj : textTrackObjAsPred(filterPredOrObj);
  return Array.from(media.textTracks).filter(filterPred);
};
const isCCOn = (el) => {
  const showingCaptions = !!el.getAttribute(
    MediaUIAttributes.MEDIA_CAPTIONS_SHOWING
  );
  const showingSubtitlesAsCaptions = !el.hasAttribute("no-subtitles-fallback") && !!el.getAttribute(MediaUIAttributes.MEDIA_SUBTITLES_SHOWING);
  return showingCaptions || showingSubtitlesAsCaptions;
};
const toggleSubsCaps = (el, forceOff = false) => {
  var _a, _b, _c, _d;
  const ccIsOn = isCCOn(el);
  if (ccIsOn) {
    const captionsShowingStr = el.getAttribute(
      MediaUIAttributes.MEDIA_CAPTIONS_SHOWING
    );
    if (captionsShowingStr) {
      const evt = new window.CustomEvent(
        MediaUIEvents.MEDIA_DISABLE_CAPTIONS_REQUEST,
        { composed: true, bubbles: true, detail: captionsShowingStr }
      );
      el.dispatchEvent(evt);
    }
    const subtitlesShowingStr = el.getAttribute(
      MediaUIAttributes.MEDIA_SUBTITLES_SHOWING
    );
    if (subtitlesShowingStr && !el.hasAttribute("no-subtitles-fallback")) {
      const evt = new window.CustomEvent(
        MediaUIEvents.MEDIA_DISABLE_SUBTITLES_REQUEST,
        { composed: true, bubbles: true, detail: subtitlesShowingStr }
      );
      el.dispatchEvent(evt);
    }
  } else if (!forceOff) {
    const [ccTrackStr] = (_b = splitTextTracksStr(
      (_a = el.getAttribute(MediaUIAttributes.MEDIA_CAPTIONS_LIST)) != null ? _a : ""
    )) != null ? _b : [];
    if (ccTrackStr) {
      const evt = new window.CustomEvent(
        MediaUIEvents.MEDIA_SHOW_CAPTIONS_REQUEST,
        { composed: true, bubbles: true, detail: ccTrackStr }
      );
      el.dispatchEvent(evt);
    } else if (!el.hasAttribute("no-subtitles-fallback")) {
      const [subTrackStr] = (_d = splitTextTracksStr(
        (_c = el.getAttribute(MediaUIAttributes.MEDIA_SUBTITLES_LIST)) != null ? _c : ""
      )) != null ? _d : [];
      if (subTrackStr) {
        const evt = new window.CustomEvent(
          MediaUIEvents.MEDIA_SHOW_SUBTITLES_REQUEST,
          { composed: true, bubbles: true, detail: subTrackStr }
        );
        el.dispatchEvent(evt);
      }
    } else {
      console.error(
        "Attempting to enable closed captions but none are available! Please verify your media content if this is unexpected."
      );
    }
  }
};
export {
  formatTextTrackObj,
  getTextTracksList,
  isCCOn,
  isMatchingPropOf,
  parseTextTrackStr,
  parseTextTracksStr,
  parseTracks,
  splitTextTracksStr,
  stringifyTextTrackList,
  textTrackObjAsPred,
  toggleSubsCaps,
  updateTracksModeTo
};
